import ForgotPassword from "../pages/User/Auth/ForgotPassword/ForgotPassword";
import Login from "../pages/User/Auth/Login/Login";
import LoginVerification from "../pages/User/Auth/LoginVerification/LoginVerification";
import ResetPassword from "../pages/User/Auth/ResetPassword/ResetPassword";
import SignUp from "../pages/User/Auth/SignUp/SignUp";
import Verification from "../pages/User/Auth/Verification/Verification";

var AuthRoutes = [
    {
        path: "login",
        name: "Login",
        layout: 'auth',
        element: <Login />
    },
    {
        path: "/register",
        name: "Register",
        layout: 'auth',
        element: <SignUp />
    },
    {
        path: "/forgot-password",
        name: "Forgot Password",
        layout: 'auth',
        element: <ForgotPassword />
    }, 
    {
        path: "/verify",
        name: "Verify Login",
        layout: 'auth',
        element: <Verification/>
    },
     
    {
        path: "/login-verify",
        name: "Verify Login",
        layout: 'auth',
        element: <LoginVerification/>
    },
    {
        path: "/reset-password",
        name: "Reset Password",
        layout: 'auth',
        element: <ResetPassword/>
    },
];
export default AuthRoutes;
